export const filtersConfig = [
  // {
  //   type: 'select',
  //   label: 'Select Sources',
  //   placeholder: '(Top 4 performing sources + own data)',
  //   key: 'sources',
  // },
  {
    type: 'radioGroup',
    label: 'Show me contributions',
    value: 'year',
    defaultValue: 'year',
    key: 'periods',
  },
];

export const periods = [
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Month',
    value: 'month',
  },
  {
    label: 'Quarter',
    value: 'quarter',
  },
  {
    label: 'Year',
    value: 'year',
  },
  {
    label: 'All',
    value: 'all',
  },
];

export const filtersData = {
  sources: [],
  periods,
};

